import React from 'react';
import { Route } from 'react-router-dom';
import { BreadcrumbsItem } from 'react-breadcrumbs-dynamic';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import ConsentsContentHolder from './ConsentsContentHolder';
import SelectCompanyFirstComponent from '../../components/SelectCompanyFirstComponent';
import { getSelectedCompany } from '../../store/selectors';
import { ConsentTab } from '../../types/enums/consentType.enum';

export default () => {
  const { t } = useTranslation();
  const selectedCompany = useSelector(getSelectedCompany);

  return (
    <>
      <BreadcrumbsItem to="/consents">{t('BREADCRUMB.CONSENTS')}</BreadcrumbsItem>
      {
        !selectedCompany ? <SelectCompanyFirstComponent /> : (
          <>
            <Route
              exact
              path="/consents"
              component={() => <ConsentsContentHolder />}
            />
            <Route
              exact
              path={`/consents/${ConsentTab.GIVEN_CONSENTS}`}
              component={() => <ConsentsContentHolder />}
            />
          </>
        )
      }
    </>
  );
};
